import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
// Source Sans is relatude.com's typeface. Self-hosted through @fontsource so the portal makes no
// third-party requests; Vite bundles the woff2 files with the rest of the assets.
import '@fontsource/source-sans-3/400.css'
import '@fontsource/source-sans-3/600.css'
import '@fontsource/source-sans-3/700.css'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
